import apiUrl from '../../../../constants'
import axios from 'axios'
//import Paginate from 'vuejs-paginate';
import {
	Validator
} from 'vee-validate'
import DatePicker from 'vue2-datepicker'
import moment from 'moment'
import CryptoJS from 'crypto-js';
import download from 'downloadjs';
import Loader from './../../shared/loader'
import Pagination from './../../shared/pagination'
import csvHelper from '../importjsontocsv';
import Vue from "vue";
import JsonExcel from "vue-json-excel";
import { BasicSelect } from 'vue-search-select'
import 'vue-search-select/dist/VueSearchSelect.css'
Vue.component("downloadExcel", JsonExcel);
export default {
	name: 'POPutawayreport',
	components: {
		//	Paginate,
		BasicSelect,
		Pagination,
		DatePicker,
		download,
		JsonExcel,
		Loader
	},
	props: [],
	data() {
		return {
			selectedmerchant: { value: '', text: '' },
			merchantList: [],
			listMerchantIdData: [],
			merchantnameFlt: '',
			isLoadingforxls: false,
			show: false,
			download: true,
			dataFilter2: '',
			reportname: '',
			brand: '',
			csvFieldsForXls: {},
			listReportDataforxls: [],
			currentPage: 1,
			totalPage: 0,
			//totalCount:0,
			pageLimit: 10,
			totalRows: 0,
			//	currentPage: 0,
			listPOPutawayReportData: [],
			listPOPutawayReportDataCsv: [],
			csvFields: [],

			// perPage: 10,
			// pageno: 0,
			// pageCount: 0,
			isLoading: false,
			formattedDate: '',
			resultCount: 0,
			listClientData: [],
			listWarehouseData: [],
			ClientErr: '',
			fromdateErr: '',
			todateErr: '',
			WarehouseErr: '',
			searchFlag: false,
			showSelectWarehouse: false,
			showSelectMerchant: false,
			showSelectClient: false,
			clientid: '',
			warehouseid: '',
			warehouse: '',
			client: '',
			pono: '',
			productid: '',
			clientproductid: '',
			rackid: '',
			fromdate: '',
			todate: '',
			user_type: '',
			putawaytype: '',
			userid: '',
			putawaytypeErr: '',
			recordLimit: 0,
			limitExeed: false,
			mid: '',
			activemrpflag:false,
			searchSLA :'',
			slaclient:[],
			slaflag:false
		}
	},
	computed: {

	},
	filters: {
		moment: function (date) {
			if (!date) return '';
			return moment(date).format('DD-MM-YY HH:mm:ss');
		}
	},
	mounted() {
		this.calldateFunction();
		var permissionEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(permissionEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		this.createdbyEmail = userdetail.email;
		this.userid = userdetail.userid;
		var today = new Date();
		this.formattedDate = moment(today).format('DD/MM/YYYY HH:mm:ss')
		this.reportname = this.$t('editedjson.poPutawayReport')
		this.reportname = this.reportname + moment().format('DD-MM-YY_HH-mm-ss') + '.xls';
		this.user_type = userdetail.utype;
		this.client = window.localStorage.getItem('selectedClient')
		this.warehouse = window.localStorage.getItem('selectedWarehouse')
		this.warehouseid= this.warehouse
		this.clientid =this.client

		if(this.clientid!=='undefined'){
			this.getMerchantList();
        }


		var slaconfig = window.localStorage.getItem('slaconfig');
		this.slaclient = JSON.parse(slaconfig);
		console.log(this.slaconfig);

		this.slaflag = this.slaclient.some(item => {
			if (item.clientid == this.clientid) {
			  return true;
			} else {
			  this.slaflag = false;
			  return false;
			}
		  });


		switch (this.user_type) {
			case 'system_user':
				this.showSelectClient = true;
				this.showSelectWarehouse = true;
				this.showSelectMerchant = true;
				// this.getClientList();
				// this.getWarehouseList();
				break;

			case 'client_user':
				this.clientid = userdetail.clientid;
				this.client = this.clientid;
				this.showSelectWarehouse = true;
				this.showSelectMerchant = true;
				this.slaflag = this.slaclient.some(item => {
                    if (item.clientid == this.clientid) {
                      return true;
                    } else {
                      this.slaflag = false;
                      return false;
                    }
                  });
				this.getMerchantList();
				// this.getWarehouseList();
				this.getActiveMrpFlag();
				if (userdetail.merchantid) {
					this.mid = userdetail.merchantid.toString()
					this.merchantnameFlt = this.mid
					this.showSelectMerchant = false;
				}

				break;

			case 'warehouse_user':
				this.warehouseid = userdetail.warehouseid;
				this.warehouse = this.warehouseid;
				this.showSelectClient = true;
				this.showSelectMerchant = true;
				// this.getClientList();
				break;

			default:
				this.$alertify.error(this.$t('common.unauthorisedError'));
				break
		}
		this.getRecordLimit()
	},
	methods: {

		selectMerchant(data) {
			this.selectedmerchant = data;
			this.merchantnameFlt = data.value;
		},
		calldateFunction: function () {
			this.currentDate = new Date().toJSON().slice(0, 10).replace(/-/g, '/');
			this.todate = this.currentDate;
			var dt = new Date(this.currentDate);
			dt.setDate(dt.getDate() - 6);
			this.fromdate = dt;
		},
		getRecordLimit() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'getRecordLimit',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then(result => {
					if (result.data) {
						this.recordLimit = result.data.data;
					}
				}, error => {
					console.error(error)
				})
		},
		startDownload() {
			this.isLoadingforxls = true;
		},
		finishDownload() {
			this.isLoadingforxls = false;
		},
		Choosetype() {
			this.show = true;
			this.download = false;
			// if (!this.limitExeed) {
			// console.log(this.limitExeed, "limit exceed-----------")	this.isLoading = false;
			this.getPOPutawayReportDataForXls(3)
			// }
		},
		export(data, filename, mime) {
			let blob = this.base64ToBlob(data, mime);
			download(blob, filename, mime);
		},

		base64ToBlob(data, mime) {
			let base64 = window.btoa(window.unescape(encodeURIComponent(data)));
			let bstr = atob(base64);
			let n = bstr.length;
			let u8arr = new Uint8ClampedArray(n);
			while (n--) {
				u8arr[n] = bstr.charCodeAt(n);
			}
			return new Blob([u8arr], {
				type: mime
			})
		},

		// getClientList() {
		// 	this.pageno = 0;
		// 	if (window.localStorage.getItem("clientList") !== null) {
		// 		var clientListEncrypt = window.localStorage.getItem('clientList');
		// 		var clientbytes = CryptoJS.AES.decrypt(clientListEncrypt.toString(), 'Key');
		// 		var plaintextclient = clientbytes.toString(CryptoJS.enc.Utf8);
		// 		this.listClientData = JSON.parse(plaintextclient);
		// 	} else {
		// 		var userToken = window.localStorage.getItem('userToken');
		// 		var myStr = userToken.replace(/"/g, '');

		// 		this.input = ({
		// 			warehouseid: this.warehouseid,
		// 		});

		// 		axios({
		// 			method: 'POST',
		// 			'url': apiUrl.api_url + 'getWarehouseAssociatedClientList',
		// 			'data': this.input,
		// 			headers: {
		// 				'Authorization': 'Bearer ' + myStr,
		// 			}
		// 		})
		// 			.then(result => {
		// 				this.listClientData = result.data.data;
		// 			}, error => {
		// 				console.error(error);
		// 			});
		// 	}
		// },

		// getWarehouseList() {
		// 	this.pageno = 0;
		// 	if (window.localStorage.getItem("warehouseList") !== null) {
		// 		var warehouseListEncrypt = window.localStorage.getItem('warehouseList');
		// 		var warehousebytes = CryptoJS.AES.decrypt(warehouseListEncrypt.toString(), 'Key');
		// 		var plaintextwarehouse = warehousebytes.toString(CryptoJS.enc.Utf8);
		// 		this.listWarehouseData = JSON.parse(plaintextwarehouse);
		// 	} else {

		// 		var userToken = window.localStorage.getItem('userToken')
		// 		var myStr = userToken.replace(/"/g, '');
		// 		this.input = ({
		// 			clientid: this.clientid,
		// 		});

		// 		axios({
		// 			method: 'POST',
		// 			'url': apiUrl.api_url + 'getClientAssociatedWarehouseList',
		// 			'data': this.input,
		// 			headers: {
		// 				'Authorization': 'Bearer ' + myStr
		// 			}
		// 		})
		// 			.then(result => {
		// 				// console.log(result.data.data);
		// 				this.listWarehouseData = result.data.data;
		// 			}, error => {
		// 				console.error(error)
		// 			})
		// 	}
		// },

		// clientSelected() {
		// 	if (this.clientid != this.client || this.clientid == this.client) {
		// 		this.clientid = this.client;
		// 		this.merchantnameFlt = '';
		// 		if (this.user_type != 'warehouse_user') {
		// 			this.listWarehouseData = []
		// 			this.merchantList = []
		// 			this.selectedmerchant = {}
		// 			this.getWarehouseList();
		// 			this.getMerchantList();
		// 			this.getActiveMrpFlag();
		// 			if (this.listWarehouseData.find(entry => entry.warehouseid === this.warehouse)) {
		// 				this.warehouse = this.warehouseid = '';
		// 			} else {
		// 				this.warehouse = ''
		// 			}
		// 		} else {
		// 			if (this.warehouseid && this.clientid);
		// 			this.merchantList = []
		// 			this.selectedmerchant = {}
		// 			this.getMerchantList();
		// 			this.getActiveMrpFlag();

		// 			// this.getPOPutawayReportData();
		// 		}
		// 	}
		// 	this.listPOPutawayReportData = [];
		// 	this.pageno = this.pageCount = 0;
		// },

		// warehouseSelected() {
		// 	this.warehouseid = this.warehouse;
		// 	this.pageno = this.pageCount = 0;
		// 	if (this.warehouseid) {
		// 		if (this.clientid) {
		// 			// this.getPOPutawayReportData();
		// 		} else {
		// 			this.getClientList();
		// 		}
		// 	}
		// },
		getMerchantList() {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			this.input = ({
				clientid: this.clientid,
			})
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'merchantList',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr,
				}
			})
				.then(result => {
					this.listMerchantData = result.data;
					this.merchantList.push({
						value: '', text: this.$t('common.selectMerchantPlaceHolder')
					}
					)
					for (var i = 0; i < this.listMerchantData.length; i++) {
						this.merchantList.push({
							'value': this.listMerchantData[i].merchantid,
							'text': this.listMerchantData[i].merchantname
						});
					}
				}, error => {
					console.error(error);
				})
		},
		async getActiveMrpFlag(){
 				 var userToken = window.localStorage.getItem('userToken');
 				 var myStr = userToken.replace(/"/g, '');
 				 this.input = ({
 					 "clientid": this.clientid,
 				 });
 			 try {

 					 axios({
 							 method: 'POST',
 							 'url': apiUrl.api_url + 'checkActivemrpFlg',
 							 'data': this.input,
 							 headers: {
 								 'Authorization': 'Bearer ' + myStr,
 							 }
 						 })
 						 .then(result => {
 							 if(result.data.data.data[0].value ==='yes'){
 								 this.activemrpflag = true;
 							 }else{
 								 this.activemrpflag = false;
 							 }
 						 }, error => {
 							 console.error(error);
 						 });

 				 } catch (err) {
 					 throw new Error(err);
 				 }
 	 },
		getPOPutawayReportDataSearch() {
			this.currentPage = 1;
			this.pageCount = 0;
			this.searchFlag = true;
			this.getPOPutawayReportData(2);
		},
		//to get client list
		getPOPutawayReportData(csvCheck = 0) {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			var fr_date = '';
			var to_date = '';
			// this.ClientErr = '';
			var dataFilter = {};
			if (csvCheck == 2) {
				this.show = false;
				this.download = true;
			}
			if (csvCheck == 2) {
				this.limitExeed = false
			}
			if (window.localStorage.getItem('selectedClient')==='undefined') {
				this.$alertify.error(this.$t('common.clientError'))
				this.pageno = this.pageCount = 0;
				this.listPOPutawayReportData = [];
				return false;
			}
			if ((this.fromdate == '' || this.fromdate == null) && (this.todate == '' || this.todate == null)) {
				this.$alertify.error(this.$t('common.selectTimeFrameError'));
				// this.pageNo = this.totalPage = 0;
				// this.listOrdersData = [];
				// this.totalRows = 0;
				return false;
			}

			var months;
			var fromDate = new Date(this.fromdate);
			var ToDate = new Date(this.todate);
			months = ToDate.getMonth() - fromDate.getMonth() + (12 * (ToDate.getFullYear() - fromDate.getFullYear()))

			if (months > 3) {
				this.$alertify.error(this.$t('common.selectTimeFrameError'));
				// this.pageNo = this.totalPage = 0;
				// this.totalRows = 0;
				// this.listOrdersData = [];
				return false;
			}
			if (this.fromdate == '' || this.fromdate == '') {

			}
			if (this.todate == '' || this.todate == '') {

			}
			if (window.localStorage.getItem('selectedWarehouse')==='undefined') {
				this.$alertify.error(this.$t('common.warehouseError'))
				this.pageno = this.pageCount = 0;
				this.listPOPutawayReportData = [];
				return false;
			}
			if (this.putawaytype == '' || this.putawaytype == null) {
				this.putawaytypeErr =  this.$t('common.stockTypeError');
				return false;
			}

			if (this.fromdate == '' || this.fromdate == null) {
				this.fromdateErr = this.$t('common.fromTypeError');
				this.pageno = this.pageCount = 0;
				this.listPOPutawayReportData = [];
				return false;
			} else {
				fr_date = this.dateFormat(this.fromdate, 0)
			}
			if (this.todate == '' || this.todate == null) {
				this.todateErr = this.$t('common.toDateError');
				this.pageno = this.pageCount = 0;
				this.listPOPutawayReportData = [];
				return false;
			} else {
				to_date = this.dateFormat(this.todate, 1)
			}

			this.isLoading = true;

			// if (csvCheck != 1)
			// this.pageno = 0;

			this.input = ({
				clientid: this.clientid,
				warehouseid:window.localStorage.getItem('selectedWarehouse'),
				pono: this.pono.trim(),
				productid: this.productid.trim(),
				clientproductid: this.clientproductid.trim(),
				rackid: this.rackid.trim(),
				fromdate: fr_date,
				todate: to_date,
				offset: (this.currentPage - 1) * 10,
				limit: this.pageLimit,
				putawaytype: this.putawaytype,
				csvData: csvCheck,
				userid: this.userid,
				merchantid: this.merchantnameFlt,
				brand: this.brand,
				slastatus : this.searchSLA

			})
			Object.entries(this.input).forEach(([k, v]) => {
				let skipkeys = ['offset', 'limit', 'csvData'];
				if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
					dataFilter[k] = v;
				}
			})
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'getPOPutawayReport',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then(result => {
					if (csvCheck == 1) {
						if (result.data.data.length > 0) {
							this.show = true;
							this.download = false;
							this.listPOPutawayReportDataCsv = [];
							this.csvFields = {
								'pono': this.$t('purchaseOrder.poSpecial'),
								'poitemid': this.$t('removeHold.poLine'),
								'productid':  this.$t('boxList.productPlaceholder'),
								'brand': this.$t('removeHold.brand'),
								'clientproductid':this.$t('product.clientProductId'),
								'eancode':  this.$t('inwardList.printData.productDetails.eanCode'),
								'productname':this.$t('inwardList.printData.productDetails.productName'),
								'mrp': this.$t('common.mrp'),
								'activemrp': this.$t('common.activemrp'),
								'storeinquantity': this.$t('removeHold.putawayQty'),
								'rackid': this.$t('common.rackID'),
								'rackinby': this.$t('removeHold.putawayDoneBy'),
								'rackindate': this.$t('removeHold.putawayDate'),
								'putawaytype':  this.$t('common.stockTypeField'),
								'merchantname': this.$t('common.merchant'),
								'slastatus': this.$t('sla.slastatus'),
								'breachedby': this.$t('sla.breachedby'),
								'sladatetime':this.$t('sla.sladatetime')
							};
							var dateFilter = [];
							if(this.activemrpflag === true){
								var skipFilter = ['count', 'merchantid','putawaycreateddate','breachdurationinmins'];
							}else {
								var skipFilter = ['count', 'merchantid','activemrp','putawaycreateddate','breachdurationinmins'];
							}
							if (!this.slaflag) {
								const keysToAdd = ['slastatus','breachedby','sladatetime'];
								keysToAdd.forEach(key => {
								  if (!skipFilter.includes(key)) {
									skipFilter.push(key);
								  }
								});
							}
							this.listPOPutawayReportDataCsv = result.data.data;

							csvHelper.data.jsonToCSV(this.$t('editedjson.poPutawayReport'), this.listPOPutawayReportDataCsv, this.csvFields, dateFilter, skipFilter, dataFilter);

							// this.jsonToCSV('POPutawayReport', this.listPOPutawayReportDataCsv, this.csvFields, dateFilter, skipFilter);
						} else {
							if (result.data.status == true) {
								this.$alertify.success(this.$t('common.reportSizeError'));
							} else {
								this.$alertify.error(result.data.msg.message);
							}
						}
					} else {
						this.listPOPutawayReportData = result.data.data;

						if (result.data.errorCode == -1) {
							this.listPOPutawayReportData = [];
							this.resultCount = 0;
						} else {
							// this.totalRows = result.data.count;
							// this.resultCount = result.data.count;
							// if (this.totalRows <= this.perPage) {
							// 	this.pageCount = 1;
							// } else {
							// 	this.pageCount = Math.ceil(this.totalRows / this.perPage);
							// }
							this.totalRows = Number(result.data.count)

							this.resultCount = result.data.count;
							if (Number(this.totalRows) > Number(this.recordLimit)) {
								this.limitExeed = true
							}
							if (this.totalRows < 10) {
								this.totalPage = 1
							} else {
								this.totalPage = Math.ceil(this.totalRows / 10);
							}
						}
					}

					this.isLoading = false;
				}, error => {
					console.error(error);
				})
		},
		getPOPutawayReportDataForXls(csvCheck = 0) {

			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			var fr_date = '';
			var to_date = '';
			// this.ClientErr = '';
			this.show = true;
			this.download = false;
			this.dataFilter2 = [];
			var value = '';
			var str = '';


			if (this.fromdate == '') {
				this.fromdateErr = this.$t('common.fromTypeError');
				this.pageno = this.pageCount = 0;
				this.listPOPutawayReportData = [];
				return false;
			} else {
				fr_date = this.dateFormat(this.fromdate, 0)
			}
			if (this.todate == '') {
				this.todateErr = this.$t('common.toDateError');
				this.pageno = this.pageCount = 0;
				this.listPOPutawayReportData = [];
				return false;
			} else {
				to_date = this.dateFormat(this.todate, 1)
			}



			// if (csvCheck != 1)
			// this.pageno = 0;
			this.isLoading = true;
			this.input = ({
				clientid: this.clientid,
				warehouseid: window.localStorage.getItem('selectedWarehouse'),
				pono: this.pono.trim(),
				productid: this.productid.trim(),
				clientproductid: this.clientproductid.trim(),
				rackid: this.rackid.trim(),
				fromdate: fr_date,
				todate: to_date,
				offset: (this.currentPage - 1) * 10,
				limit: this.pageLimit,
				putawaytype: this.putawaytype,
				csvData: csvCheck,
				userid: this.userid,
				merchantid: this.merchantnameFlt,
				brand: this.brand,

			})
			Object.entries(this.input).forEach(([k, v]) => {
				let skipkeys = ['offset', 'limit', 'csvData'];
				if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
					value += k + ':' + v + ','
					this.dataFilter2 = str.concat(value);

				}
			})

			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'getPOPutawayReport',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then(result => {
					this.isLoading = false;
					if (csvCheck == 3) {
						if (result.data.data.length > 0) {
							this.listReportDataforxls = [];
							this.csvFieldsForXls =[];
							this.csvFieldsForXls[this.$t('purchaseOrder.poSpecial')] =  'pono';
							this.csvFieldsForXls[this.$t('removeHold.poLine')] = 'poitemid';
							this.csvFieldsForXls[this.$t('boxList.productPlaceholder')] = 'productid';
							this.csvFieldsForXls[this.$t('product.clientProductId')] =  'clientproductid';
							this.csvFieldsForXls[this.$t('inwardList.printData.productDetails.eanCode')] = 'eancode';
							this.csvFieldsForXls[this.$t('printProductDetails.productName')] = 'productname';
							this.csvFieldsForXls[this.$t('removeHold.brand')] = 'brand';
							this.csvFieldsForXls[this.$t('common.mrp')] = 'mrp';
							if(this.activemrpflag === true){
								this.csvFieldsForXls[this.$t('common.activemrp')] = 'activemrp';
							}
							this.csvFieldsForXls[this.$t('removeHold.putawayQty')] = 'storeinquantity';
							this.csvFieldsForXls[this.$t('common.rackID')] = 'rackid';
							this.csvFieldsForXls[this.$t('removeHold.putawayDoneBy')] = 'rackinby';
							this.csvFieldsForXls[this.$t('common.merchant')] = 'merchantname';
							this.csvFieldsForXls[this.$t('removeHold.putawayDate')] = 'rackindate';
							this.csvFieldsForXls[this.$t('common.stockTypeField')] = 'putawaytype';
							this.csvFieldsForXls[this.$t('sla.slastatus')]='slastatus',
							this.csvFieldsForXls[this.$t('sla.breachedby')]='breachedby';
							this.csvFieldsForXls[this.$t('sla.sladatetime')]='sladatetime';

							this.listReportDataforxls = result.data.data;
							const keysToRemove = [this.$t('sla.slastatus'),this.$t('sla.breachedby'),this.$t('sla.sladatetime')];
							if (!this.slaflag) {
							  keysToRemove.forEach(key => {
								if (this.csvFieldsForXls.hasOwnProperty(key)) {
								  delete this.csvFieldsForXls[key];
								}
							  });
							}

						} else {
							if (result.data.status == true) {
								this.$alertify.success(this.$t('common.reportSizeError'));
							} else {
								this.$alertify.error(result.data.msg.message);
							}
						}
					}
				}, error => {
					console.error(error);
				})
		},
		//to get pagination
		// getPaginationData(currentPage) {
		// 	this.pageno = (currentPage - 1) * this.perPage;
		// 	this.getPOPutawayReportData();
		// },
		onPageChange(page) {
			this.currentPage = page;
			this.getPOPutawayReportData()
		},
		dateFormat(date, toFrom) {
			if (!toFrom)
				toFrom = '00:00:00'
			else
				toFrom = '23:59:59'
			if (!date)
				return '';
			return moment(date).format('YYYY-MM-DD ' + toFrom);
		},

		dateFormatFRT(date) {
			if (!date) return '';
			return moment(date).format('DD-MM-YY HH:mm:ss');
		},

		//to reset search form
		resetSearchForm() {
			this.show = false;
			this.searchSLA=''
			this.download = true;
			this.ClientErr = '';
			this.fromdateErr = '';
			this.todateErr = '';
			this.putawaytypeErr = '';
			this.putawaytype = '';
			this.productid = '';
			this.clientproductid = '';
			this.orderid = '';
			this.rackid = '';
			this.brand = '',
				this.pageno = 0;
			this.totalRows = 0;
			this.resultCount = 0;
			this.listPOPutawayReportData = [];
			this.fromdate = '';
			this.pono = '';
			this.todate = '';
			this.merchantnameFlt = '';
			this.searchFlag = false;
			this.selectedmerchant = {}
			// if (this.user_type == 'warehouse_user') {
			// 	this.client = '';
			// 	// this.merchantList = []
			// }
			// else if (this.user_type == 'client_user')
			// 	this.warehouse = '';
			// else {
			// 	this.client = '';
			// 	this.warehouse = '';
			// 	// this.merchantList = []
			// }
		},
	}
}



// WEBPACK FOOTER //
// ./src/views/components/reports/poPutawayReport/poPutawayReport.component.js